export function getStepLabel(step, listingType, labels) {
  switch (step) {
    case '1':
      return labels.listingStepFillInTheBasics;
    case '2':
      {
        if (listingType === 'consultant') {
          return labels.listingStepAddDetails;
        }
        return labels.listingStepSetPricing;
      }
    case '2-1':
      if (listingType === 'consultant') {
        return labels.listingStepDescribeYourServices;
      }
      return labels.listingStepPriceYourSolution;
    case '2-2':
      if (listingType === 'consultant') {
        return labels.listingStepIncludeVisuals;
      }
      return labels.listingStepGetApproved;
    case '3':
      if (listingType === 'consultant') {
        return labels.listingStepGrowYourBusiness;
      }
      return labels.listingStepAddDetails;
    case '3-1':
      return labels.listingStepDescribeYourSolution;
    case '3-2':
      return labels.listingStepIncludeVisuals;
    case '4':
      return labels.listingStepLinkYourSolution;
    case '5':
      return labels.listingStepGrowYourBusiness;
    default:
      return 'UNKNOWN STEP';
  }
}
export function getStepsList(listingType, labels) {
  const commonSteps = [{
    number: 1,
    title: labels.listingStepFillInTheBasics,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'connected_apps'
  }];
  if (listingType === 'consultant') {
    return [...commonSteps, {
      number: 2,
      title: labels.listingStepAddDetails,
      admonition: '',
      selected: false,
      icon: '',
      publishedIcon: 'builder',
      subSteps: [{
        number: 1,
        title: labels.listingStepDescribeYourServices,
        selected: false
      }, {
        number: 2,
        title: labels.listingStepIncludeVisuals,
        selected: false
      }]
    }, {
      number: 3,
      title: labels.listingStepGrowYourBusiness,
      admonition: '',
      selected: false,
      icon: '',
      publishedIcon: 'salesforce1'
    }];
  }
  return [...commonSteps, {
    number: 2,
    title: labels.listingStepSetPricing,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'pricing_workspace',
    subSteps: [{
      number: 1,
      title: labels.listingStepPriceYourSolution,
      selected: false
    }, {
      number: 2,
      title: labels.listingStepGetApproved,
      selected: false
    }]
  }, {
    number: 3,
    title: labels.listingStepAddDetails,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'builder',
    subSteps: [{
      number: 1,
      title: labels.listingStepDescribeYourSolution,
      selected: false
    }, {
      number: 2,
      title: labels.listingStepIncludeVisuals,
      selected: false
    }]
  }, {
    number: 4,
    title: labels.listingStepLinkYourSolution,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'recipe'
  }, {
    number: 5,
    title: labels.listingStepGrowYourBusiness,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'salesforce1'
  }];
}
export function getSRWStepList(labels) {
  const steps = [{
    number: 1,
    title: labels.srwStepTwoTitle,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'chat',
    hasBottomLine: false,
    isEnabled: true
  }, {
    number: 2,
    title: labels.srwStepThreeTitle,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'hierarchy',
    hasBottomLine: false,
    isEnabled: true
  }, {
    number: 3,
    title: labels.srwStepFourTitle,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'record_update',
    hasBottomLine: false,
    isEnabled: true
  }, {
    number: 4,
    title: labels.srwStepFiveTitle,
    admonition: '',
    selected: false,
    icon: '',
    publishedIcon: 'tracker',
    hasBottomLine: false,
    isEnabled: true
  }];
  return steps;
}